'use strict';

angular.module('mean.general-tasks').controller('GeneralTasksController', ['$scope', 'Global', 'Menus', 'GeneralTasks', '$filter', 'tradeCodeService', 'CombinationService',
    function ($scope, Global, Menus, GeneralTasks, $filter, tradeCodeService, CombinationService) {

        $scope.global = Global;
        $scope.tasks = [];
        $scope.pType = {};
        $scope.combOptions = [];
        $scope.current_menu = 'Trades';
        $scope.menues = ['Trades', 'Combinations', 'General Tasks', 'Subtasks', 'User General Tasks', 'User Subtasks', 'Trade Subtasks'];

        $scope.formValue = { trade: '', company: '' };
        $scope.trade_array = tradeCodeService.getArray();

        $scope.companyCodes = [];
        for (var i = 0; i < 1000; i++) {
            if(i < 10) { 
                $scope.companyCodes.push('00' + i);
            } else if(i<100) {
                $scope.companyCodes.push('0' + i);
            } else {
                $scope.companyCodes.push(i.toString());
            }
        }

        $scope.tradeCodes = [];
        for (var i = 0; i < 100; i++) {
            if(i < 10) {
                $scope.tradeCodes.push('0' + i);
            } else {
                $scope.tradeCodes.push(i.toString());
            }
        }

        console.log('in the gen tasks controller');

        $scope.hasAuthorization = function (task) {
            if (!task || !task.user) return false;
            return $scope.global.isAdmin || task.user._id === $scope.global.user._id;
        };

        $scope.init = function () {
            CombinationService.query({ type: 'adminQuey'}, function (combination) {
                combination.forEach(item => {
                    $scope.combOptions.push({ id: item._id, type: item.projectType, location: item.geoLocation });
                })
            });
        };

        $scope.getGeneralTasks = function () {
            if (this.pType) {
                GeneralTasks.query({
                    projectType: this.pType.type, 
                    geoLocation: this.pType.location
                }, function (tasks) {
                    $scope.tasks = tasks;
                });
            }
        }

        $scope.getUserGeneralTasks = function () {
            if (this.formValue) {
                GeneralTasks.query({
                    trade: this.formValue.trade, 
                    isCustom: true
                }, function (tasks) {
                    $scope.user_tasks = tasks;
                });
            }
        }

        /**
         * change tab selection
         * @param {menu}
         * @returns {void}
         */
        $scope.onSelect = (menu) => {
            $scope.current_menu = menu;
            $scope.combOptions = [];
            CombinationService.query({ type: 'adminQuey'}, function (combination) {
                combination.forEach(item => {
                    $scope.combOptions.push({ id: item._id, type: item.projectType, location: item.geoLocation });
                })
            });
            $scope.trade_array = tradeCodeService.getArray();
        }

        $scope.add = function () {
            if (!$scope.tasks) $scope.tasks = [];

            var task = new GeneralTasks({
                task_code: $scope.task_code,
                trade: $scope.trade,
                task: $scope.task,
                task_name: $scope.task_name,
                isCustom: false,
                userId: '',
                location: $scope.location
            });

            task.$save(function (response) {
                $scope.tasks.push(response);
            });

            this.task_code = this.trade = this.task = this.task_name = '';
        };

        $scope.remove = function (task) {
            for (var i in $scope.tasks) {
                if ($scope.tasks[i] === task) {
                    $scope.tasks.splice(i, 1);
                }
            }

            task.$remove();
        };

        $scope.update = function (task) {
            task.task_code = task.trade + task.task;
            task.$update();
        };

        $scope.getTradeName = function (id) {
            return tradeCodeService.getName(id);
        };

        $scope.fileSelected = function () {
            var lines, lineNumber, data, length;
            var _self = this;
            lines = this.$parent.fileContent.split('\n');
            lineNumber = 0;
            var holder = [];
            var is_clean = true;
            GeneralTasks.query({}, function (tasks) {
                for (var i = lines.length - 1; i > 0; i--) {
                    var l = lines[i];

                    lineNumber++;
                    data = l.split(',');

                    if (!data[0]) continue;

                    var inlist = $filter('filter')(holder, { 'task_code': data[3] }, true);
                    if (inlist.length > 0) {
                        alert('Task code ' + data[3] + ' already exists. Remove all, fix, and retry.');
                        is_clean = false;
                        break;
                    }

                    inlist = $filter('filter')(holder, { 'task_name': data[4] }, true);
                    if (inlist.length > 0) {
                        alert('Task name ' + data[4] + ' already exists. Remove all, fix, and retry.');
                        is_clean = false;
                        break;
                    }

                    var order = data[0];
                    var trade = data[1];
                    var trade_code = data[2];
                    var task_code = data[3];
                    var task_name = data[4];
                    var projectType = data[5];
                    var geoLocation = data[6];
                    var location = data[7];

                    var array = data[3].split('', 4);

                    if (_self.pType && _self.pType.type && _self.pType.location) {
                        projectType = _self.pType.type;
                        geoLocation = _self.pType.location;
                    } else {
                        continue;
                    }

                    var isDuplicate = $filter('filter')(tasks, {
                        'task': array[2] + array[3],
                        'task_code': task_code,
                        'task_name': task_name,
                        'projectType': projectType,
                        'geoLocation': geoLocation
                    }, true);

                    if (isDuplicate.length === 0) {
                        var task = new GeneralTasks({
                            order: Number(order),
                            trade: trade_code,
                            task_code: task_code,
                            task: array[2] + array[3],
                            task_name: task_name,
                            projectType: projectType,
                            geoLocation: geoLocation,
                            isCustom: false,
                            userId: '',
                            location: location
                        });

                        holder.push(task);
                    }

                }

                if (is_clean && holder.length) {
                    var tasks2 = _self.$parent.tasks;

                    GeneralTasks.bulkAdd(holder, function (results) {
                        results.forEach(function (item) {
                            tasks2.push(item);
                        });
                    });

                    delete _self.$parent.fileContent;
                }
            });
        };

        $scope.ConvertToCSV = function (objArray) {
            var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
            var str = 'order,trade,trade_code,task_code,task_name,project_type,geographical_location,location\r\n';

            for (var i = 0; i < array.length; i++) {
                str += array[i].order + ',' + tradeCodeService.getName(array[i].trade) + ','
                    + array[i].trade + ',' + array[i].task_code + ',' + array[i].task_name + ','
                    + array[i].projectType + ',' + array[i].geoLocation + ',' + array[i].location.trim();
                str += '\r\n';
            }

            return str;
        };

        $scope.exportFile = function () {

            $scope.tasks = $filter('orderBy')($scope.tasks, 'order');
            var dataUrl = 'data:text/csv;utf-8,' + encodeURI($scope.ConvertToCSV($scope.tasks));
            var link = document.createElement('a');
            angular.element(link)
                .attr('href', dataUrl)
                .attr('download', 'general-tasks.csv') // Pretty much only works in chrome
            link.click();
        };

        $scope.deleteAll = function () {
            $scope.tasks.forEach(function (task) {
                task.$delete();
            });
            $scope.tasks = [];
        };

        $scope.editLocation = function (item) {
            item.locationEditing = true;
        };

        $scope.doneLocationEditing = function (item) {
            if (!item.locationEditing) return;

            $scope.update(item);

            item.locationEditing = false;
        };

        $scope.editTrade = function (item) {
            item.tradeEditing = true;
        };

        $scope.doneTradeEditing = function (item, choice) {
            if (!item.tradeEditing) return;

            item.trade = choice.value;

            $scope.update(item);

            item.tradeEditing = false;
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/general-tasks/public/controllers/generalTasks.js